module.exports = __webpack_public_path__ + "img/_members_grey.ce751434.svg";